import { Modal } from 'antd';
import { TaskAttachment } from '../../types/TaskAttachment';
import { BaseButton } from '../UI/BaseButton';
interface DeleteTaskAttachmentModalProps {
  attachments: TaskAttachment[];
  open: boolean;
  onOk: () => void;
  onCancel: () => void;
}

export const DeleteTaskAttachmentModal = (props: DeleteTaskAttachmentModalProps) => {
  const { open, onCancel, onOk, attachments } = props;
  return (
    <Modal
      title={
        <div className="text-brand-grey-dark text-base font-semibold mx-4 mt-3">
          You are about to delete the following attachment{attachments.length > 1 ? 's' : ''}:
        </div>
      }
      open={open}
      onOk={onOk}
      onCancel={onCancel}
      centered
      width={640}
      footer={
        <div className="flex justify-end gap-2">
          <BaseButton type="secondary" size="medium" onClick={onCancel}>
            Cancel
          </BaseButton>
          <BaseButton type="primary" size="medium" danger onClick={onOk}>
            {attachments.length > 1 ? 'Delete Attachments' : 'Delete Attachment'}
          </BaseButton>
        </div>
      }
    >
      <div className="mx-4 mb-10 mt-6 p-3 bg-neutral-200 rounded flex flex-col gap-2 items-center justify-start text-brand-grey-dark text-sm font-medium ">
        {attachments.map((attachment) => (
          <div key={attachment.id} className="w-full truncate overflow-hidden">
            {attachment.filename}
          </div>
        ))}
      </div>
    </Modal>
  );
};
